import { Pagination, PaginationContent, PaginationEllipsis, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '../../ui/Pagination';

export default function SharedPagination({ page, setPage, totalPages }: { page: number; setPage: React.Dispatch<React.SetStateAction<number>>; totalPages: number }) {
  const renderPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(
          <PaginationItem key={i}>
            <PaginationLink href='#' onClick={() => setPage(i)} isActive={i === page}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }
    } else {
      const startPage = Math.max(1, page - 2);
      const endPage = Math.min(totalPages, page + 2);
      if (startPage > 1) {
        pageNumbers.push(
          <PaginationItem key={1}>
            <PaginationLink href='#' onClick={() => setPage(1)}>
              1
            </PaginationLink>
          </PaginationItem>
        );
        if (startPage > 2) {
          pageNumbers.push(
            <PaginationItem key='ellipsis_start'>
              <PaginationEllipsis />
            </PaginationItem>
          );
        }
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(
          <PaginationItem key={i}>
            <PaginationLink href='#' onClick={() => setPage(i)} isActive={i === page}>
              {i}
            </PaginationLink>
          </PaginationItem>
        );
      }

      if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
          pageNumbers.push(
            <PaginationItem key='ellipsis_end'>
              <PaginationEllipsis />
            </PaginationItem>
          );
        }
        pageNumbers.push(
          <PaginationItem key={totalPages}>
            <PaginationLink href='#' onClick={() => setPage(totalPages)}>
              {totalPages}
            </PaginationLink>
          </PaginationItem>
        );
      }
    }

    return pageNumbers;
  };
  return (
    <div className='flex justify-center max-sm:flex-col items-center w-full p-0'>
      <Pagination className='p-0'>
        <PaginationContent className='w-full justify-evenly'>
          <PaginationItem>
            {/* <button onClick={() => setPage((page: number) => Math.max(1, page - 1))} disabled={page === 1}> */}
            <PaginationPrevious href='#' onClick={() => setPage((page: number) => Math.max(1, page - 1))} aria-disabled={page === 1} className={page === 1 ? 'pointer-events-none opacity-50' : 'cursor-pointer'} />
            {/* </button> */}
          </PaginationItem>
          {renderPageNumbers()}
          <PaginationItem>
            {/* <button className='disabled:cursor-not-allowed' onClick={() => setPage((prev) => prev + 1)} disabled={page >= totalPages}> */}
            <PaginationNext href='#' aria-disabled={page >= totalPages} onClick={() => setPage((prev) => prev + 1)} className={page >= totalPages ? 'pointer-events-none opacity-50' : 'cursor-pointer'} />
            {/* </button> */}
          </PaginationItem>
        </PaginationContent>
      </Pagination>
    </div>
  );
}
